import { z } from 'zod';
import { BaseValidations } from '@anytag/shared-validations';

export const CreateBusinessCenterFormSchema = z.object({
  name: BaseValidations.NameSchema,
  timezone: BaseValidations.TimezoneSchema
});
